import Component from '@bythepixel/component-loader';
import DEFAULTS from '@Components/form/_config';
import { handleComponentError } from '@Core/helpers/functions';

export default class Form extends Component {
  static selector = `[${DEFAULTS.form}]`;

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.form = this.$container;
    this.route = this.form.getAttribute(this.$options.formRoute);
    this.button = this.form.querySelector(`[${this.$options.submitButton}]`);
    this.fieldset = this.form.querySelector(`[${this.$options.formFieldset}]`);
    this.secureInputId = `${this.form.id}_secureInput`;

    this.mount();
  }

  appendSecureInput() {
    if (document.getElementById(this.secureInputId)) {
      return;
    }

    const input = document.createElement('input');

    input.type = 'hidden';
    input.name = 'secure';
    input.value = 'secure';
    input.id = this.secureInputId;

    this.form.appendChild(input);
  }

  async handleFormSubmission(event) {
    this.setFormState('loading');
    this.disableElement(this.button, true);
    this.appendSecureInput();

    const formData = new FormData(event.target);
    const response = await this.postFormData(formData);
    await this.handleServerResponse(response);

    this.disableElement(this.button, false);
  }

  async postFormData(formData) {
    return fetch(this.route, {
      method: 'post',
      body: formData,
    });
  }

  async handleServerResponse(response) {
    const data = await response.json();

    switch (response.status) {
    case 200:
      this.setFormState('success');
      this.disableElement(this.fieldset, true);
      break;
    case 422:
    case 400:
      this.setFormState('invalid');
      break;
    default:
      this.setFormState('error');
      this.disableElement(this.fieldset, true);
      break;
    }

    return data;
  }

  disableElement(element, disabled) {
    element.toggleAttribute('disabled', disabled);
  }

  setFormState(state) {
    this.form.setAttribute(this.$options.formState, state);
  }

  mount() {
    handleComponentError([
      [!this.route, 'Form element is missing an API route.'],
      [!this.fieldset, 'Form element inputs need a fieldset wrapper.'],
      [!this.button, 'Form element has no submit button.'],
    ]);

    this.form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (!this.button.disabled) {
        this.handleFormSubmission(event);
      }
    });
  }
}
